import { useState, useEffect, useRef } from 'react';
import '../Styles/Stepper.css';
import TopArrow from '../../../../../assets/svg/DesignIcons/toparrow';

const Stepper = ({ currentStep, scrollToStep, step }) => {
    const [isMobile, setIsMobile] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const [isFooterVisible, setIsFooterVisible] = useState(false);
    const stepperRef = useRef(null);
    const footerRef = useRef(null);

    // useEffect(() => {
    //     const handleResize = () => setIsMobile(window.innerWidth >= 768);
    //     handleResize();
    //     window.addEventListener('resize', handleResize);
    //     return () => window.removeEventListener('resize', handleResize);
    // }, []);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const viewportHeight = window.innerHeight;
            if (scrollY > 2 * viewportHeight) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
                setIsOpen(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);


    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isOpen && stepperRef.current && !stepperRef.current.contains(e.target)) {
                triggerClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen]);

    const triggerClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setIsOpen(false);
            setIsClosing(false);
        }, 300);
    };

    const toggleOpen = () => {
        if (isOpen) {
            triggerClose();
        } else {
            setIsOpen(true);
        }
    };

    const handleClickStep = (stepIndex, e, key) => {
        scrollToStep(stepIndex, e, key);
        if (isMobile) triggerClose();
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => setIsFooterVisible(entry.isIntersecting),
            { threshold: 0.1 }
        );

        const footerElement = document.querySelector('#footer-root'); // Target the footer root
        if (footerElement) {
            footerRef.current = footerElement;
            observer.observe(footerElement);
        }

        return () => {
            if (footerRef.current) {
                observer.unobserve(footerRef.current);
            }
        };
    }, []);


    return (
        <>
            {isMobile && isVisible && !isFooterVisible && (

                <div
                    className={`mobile-stepper-wrapper ${isOpen ? 'open' : ''}`}
                    ref={stepperRef}
                >
                    {!isOpen && !isClosing ? (
                        <div className="stepper-toggle" onClick={toggleOpen}>
                            <div className={`chevron-container ${isOpen ? 'rotate' : ''}`}><TopArrow /></div>
                            <div className={`circle-number ${isOpen ? 'rotate' : ''}`}>
                                {currentStep}
                            </div>
                        </div>
                    ) : (
                        <div className={`stepper-rail-wrapper ${isClosing ? 'closing' : 'expand'}`}>
                            <div className="rail-container">

                                <div className="rail-item" onClick={toggleOpen}>
                                    <span className="rail-label">Cancel</span>
                                    <div className="rail-number-outer first">
                                        <div className="outer-circle-ring-2">
                                            <div className="rail-number-inner">×</div>
                                        </div>
                                    </div>
                                </div>

                                {step.map((item) => (
                                    <div
                                        key={item.step}
                                        className={`rail-item ${currentStep === item.step ? 'active' : ''}`}
                                        onClick={(e) => handleClickStep(item.step - 1, e, item.key)}
                                    >
                                        <span className="rail-label">{item.label}</span>
                                        <div className={`rail-number-outer ${item.step === step.length ? 'last' : ''}`}>
                                            <div className="outer-circle-ring-2">
                                                <div className="rail-number-inner">{item.step}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            )}

            {/* {!isMobile && (
                <div className="stepper">
                    <div className="stepper-row">
                        {step.map((item, index) => (
                            <div
                                key={item.step}
                                className={`step-item ${currentStep === item.step
                                    ? "active"
                                    : currentStep > item.step
                                        ? "previous"
                                        : ""
                                    } ${index !== step.length - 1 ? "has-line" : ""}`}
                                onClick={(e) => scrollToStep(item.step - 1, e, item.key)}
                            >
                                <div className="circle-outer">
                                    <div className="circle">{item.step}</div>
                                </div>
                                <div className="stepper-label">{item.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            )} */}
        </>
    );
};

export default Stepper;
